"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRRuleUntilOfSlotType = exports.slotRecurrenceTypeSchema = exports.slotRecurrenceTypes = exports.getRRuleByweekdayOfDayNumber = exports.getRRuleByweekdayOfDayString = exports.rruleSchema = exports.rruleByWeekDay = void 0;
const date_fns_1 = require("date-fns");
const zod_1 = require("zod");
exports.rruleByWeekDay = ['mo', 'tu', 'we', 'th', 'fr', 'sa'];
exports.rruleSchema = zod_1.z.object({
    freq: zod_1.z.string(),
    interval: zod_1.z.number().optional(),
    dtstart: zod_1.z.string(),
    byweekday: zod_1.z.array(zod_1.z.enum([...exports.rruleByWeekDay, 'su'])),
    until: zod_1.z.string().optional().nullable(),
});
const getRRuleByweekdayOfDayString = (day) => {
    switch (day) {
        case 'monday': {
            return 'mo';
        }
        case 'tuesday': {
            return 'tu';
        }
        case 'wednesday': {
            return 'we';
        }
        case 'thursday': {
            return 'th';
        }
        case 'friday': {
            return 'fr';
        }
        case 'saturday': {
            return 'sa';
        }
    }
};
exports.getRRuleByweekdayOfDayString = getRRuleByweekdayOfDayString;
const getRRuleByweekdayOfDayNumber = (day) => {
    if (day === 0) {
        return 'su';
    }
    return exports.rruleByWeekDay[day - 1];
};
exports.getRRuleByweekdayOfDayNumber = getRRuleByweekdayOfDayNumber;
exports.slotRecurrenceTypes = [
    'once',
    '3-months',
    '6-months',
    '9-months',
    '12-months',
];
exports.slotRecurrenceTypeSchema = zod_1.z.enum(exports.slotRecurrenceTypes);
const getRRuleUntilOfSlotType = (startAt, slotType) => {
    switch (slotType) {
        case '3-months': {
            return (0, date_fns_1.addMonths)(startAt, 3);
        }
        case '6-months': {
            return (0, date_fns_1.addMonths)(startAt, 6);
        }
        case '9-months': {
            return (0, date_fns_1.addMonths)(startAt, 9);
        }
        case '12-months': {
            return (0, date_fns_1.addMonths)(startAt, 12);
        }
        default: {
            return null;
        }
    }
};
exports.getRRuleUntilOfSlotType = getRRuleUntilOfSlotType;
